/**
 * NO04 - Ordre Search Actions
 */

import NO04, { NO04SearchParams } from '../../models/NO04';
import * as actionTypes from './actionTypesNO04';

export const NO04SearchRequest = (searchParams: NO04SearchParams) => ({
  type: actionTypes.NO04_SEARCH_REQUEST,
  payload: searchParams,
});

export const NO04SearchSuccess = (orders: NO04[], hasMore: boolean) => ({
  type: actionTypes.NO04_SEARCH_SUCCESS,
  payload: { orders, hasMore },
});

export const NO04SearchFailure = (error: string) => ({
  type: actionTypes.NO04_SEARCH_FAILURE,
  payload: error,
});

export const NO04LoadMoreRequest = (searchParams: NO04SearchParams) => ({
  type: actionTypes.NO04_LOAD_MORE_REQUEST,
  payload: searchParams,
});

export const NO04LoadMoreSuccess = (orders: NO04[], hasMore: boolean) => ({
  type: actionTypes.NO04_LOAD_MORE_SUCCESS,
  payload: { orders, hasMore },
});

export const NO04LoadMoreFailure = (error: string) => ({
  type: actionTypes.NO04_LOAD_MORE_FAILURE,
  payload: error,
});

export const NO04ClearResults = () => ({
  type: actionTypes.NO04_CLEAR_RESULTS,
});

export const NO04ResetForm = (isEnabled: boolean) => ({
  type: actionTypes.NO04_RESET_FORM,
  payload: isEnabled,
});

export const NO04ClearComponentStore = () => ({
  type: actionTypes.NO04_CLEAR_COMPONENT_STORE,
});

export const NO04OrderDetailRequest = (companyId: number, orderNumber: string) => ({
  type: actionTypes.NO04_ORDER_DETAIL_REQUEST,
  payload: { companyId, orderNumber },
});

export const NO04OrderDetailSuccess = (data: any) => ({
  type: actionTypes.NO04_ORDER_DETAIL_SUCCESS,
  payload: data,
});

export const NO04OrderDetailFailure = (error: string) => ({
  type: actionTypes.NO04_ORDER_DETAIL_FAILURE,
  payload: error,
});

export const NO04OrderDetailClear = () => ({
  type: actionTypes.NO04_ORDER_DETAIL_CLEAR,
});
